import { Type, screenSmMax, mobileBallad } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { DELAYS, fadeInAnimation, withAnimationContext, } from '../../Animations';
export const Body = withAnimationContext(styled(Type.p).attrs({
    variant: 'ballad',
    className: 'body',
}) `
    /**TODO fix */
    ${fadeInAnimation(DELAYS.FOURTH)};
    @media (max-width: ${screenSmMax}) {
      ${() => mobileBallad}
    }
  `);
//# sourceMappingURL=Body.js.map